import { render, staticRenderFns } from "./RegoSearch.vue?vue&type=template&id=dfa43d36&"
import script from "./RegoSearch.vue?vue&type=script&lang=js&"
export * from "./RegoSearch.vue?vue&type=script&lang=js&"
import style0 from "./RegoSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports